/* eslint-disable @typescript-eslint/no-require-imports */

import { useFonts } from 'expo-font';
import { FONTS } from '@sweetgreen/garnish';

const FONT_CONFIG = {
  [FONTS.GRENETTE_PRO]: require('../../../assets/fonts/otf/GrenettePro-Regular.otf'),
  [FONTS.GRENETTE_PRO_REGULAR]: require('../../../assets/fonts/otf/GrenettePro-Regular.otf'),
  [FONTS.GRENETTE_PRO_LIGHT]: require('../../../assets/fonts/otf/GrenettePro-Light.otf'),

  [FONTS.SWEET_SANS]: require('../../../assets/fonts/otf/SweetSans-Regular.otf'),
  [FONTS.SWEET_SANS_REGULAR]: require('../../../assets/fonts/otf/SweetSans-Regular.otf'),
  [FONTS.SWEET_SANS_BOLD]: require('../../../assets/fonts/otf/SweetSans-Bold.otf'),

  [FONTS.SWEET_SANS_CONDENSED]: require('../../../assets/fonts/otf/SweetSansCondensed-Bold.otf'),
  [FONTS.SWEET_SANS_CONDENSED_BOLD]: require('../../../assets/fonts/otf/SweetSansCondensed-Bold.otf'),

  [FONTS.SWEET_SANS_NARROW]: require('../../../assets/fonts/otf/SweetSansNarrow-Regular.otf'),
  [FONTS.SWEET_SANS_NARROW_REGULAR]: require('../../../assets/fonts/otf/SweetSansNarrow-Regular.otf'),
  [FONTS.SWEET_SANS_NARROW_BOLD]: require('../../../assets/fonts/otf/SweetSansNarrow-Bold.otf'),

  [FONTS.SWEET_SANS_TEXT]: require('../../../assets/fonts/otf/SweetSansText-Regular.otf'),
  [FONTS.SWEET_SANS_TEXT_REGULAR]: require('../../../assets/fonts/otf/SweetSansText-Regular.otf'),
  [FONTS.SWEET_SANS_TEXT_BOLD]: require('../../../assets/fonts/otf/SweetSansText-Bold.otf'),

  [FONTS.SWEET_SANS_WIDE]: require('../../../assets/fonts/otf/SweetSansWide-Regular.otf'),
  [FONTS.SWEET_SANS_WIDE_REGULAR]: require('../../../assets/fonts/otf/SweetSansWide-Regular.otf'),
  [FONTS.SWEET_SANS_WIDE_BOLD]: require('../../../assets/fonts/otf/SweetSansWide-Bold.otf'),
};

export const useOrderAppFonts = () => useFonts(FONT_CONFIG);
